import { all, takeEvery } from 'redux-saga/effects';
import { FETCH_SEASON_LEADERS } from '../actions';
import { fetchSeasonLeaders } from './fetch-season-leaders';

/**
 *
 */
export function* seasonLeadersRootSaga() {
    yield all([
        // @ts-ignore
        takeEvery(FETCH_SEASON_LEADERS.REQUEST, fetchSeasonLeaders)
    ]);
}
